import React from 'react';
import { CheckIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react';

interface PROPS {
  planType: string;
  charges: string;
  planDuration: string;
  targetPeople: string;
  onClick?: () => void;
  btnText: string;
  current?: boolean;
}

export default function PlanCard({
  planType,
  charges,
  planDuration,
  targetPeople,
  onClick,
  btnText,
  current,
}: PROPS) {
  return (
    <Box
      border={
        current ? '1px solid #D3BB8A' : '1px solid rgba(242, 243, 245, 0.14)'
      }
      borderRadius='30px'
      width={planType === 'Free' ? '340px' : '475px'}
      height='600px'
      overflow='hidden'
    >
      {/* Current Plan */}
      {current && (
        <Box
          height={['40px']}
          width={['inherit']}
          display='flex'
          justifyContent='center'
          alignItems='center'
          background='linear-gradient(255deg, #1D2531 -1.47%, rgba(211, 187, 138, 0.00) 100%)'
          borderTopRadius='28px'
        >
          <Text
            fontFamily='Metal'
            textTransform='uppercase'
            color={current ? '#D3BB8A' : 'white'}
            fontSize={['14px']}
          >
            Current Plan
          </Text>
        </Box>
      )}

      {/* Plan Name */}
      <Box
        p={['30px']}
        height={['210px']}
        display='flex'
        flexDirection='column'
        alignItems='flex-start'
        background='#1D2531'
        borderTopRadius={current ? 'unset' : '28px'}
        position='relative'
      >
        <Box display='flex' flexDirection='column' gap={2}>
          <Text
            fontFamily='Metal'
            textTransform='uppercase'
            fontSize={['35px']}
            lineHeight={['35px']}
            color='white'
          >
            {planType}
          </Text>

          {charges?.length > 0 && (
            <Box display='flex' alignItems='flex-end' gap={2}>
              <Text
                fontFamily='Metal'
                textTransform='capitalize'
                fontSize={['25px']}
                lineHeight={['25px']}
                color='white'
              >
                {charges}
              </Text>
              <Text
                fontFamily='Metal'
                textTransform='lowercase'
                fontSize={['15px']}
                color='white'
              >
                {planDuration}
              </Text>
            </Box>
          )}
          <Text
            fontFamily='Metal'
            textTransform='lowercase'
            fontSize={['12px']}
            color='white'
            whiteSpace='pre-line'
          >
            {targetPeople}
          </Text>
        </Box>
        {btnText && btnText?.length > 0 && (
          <Button
            mt={['auto']}
            textTransform='uppercase'
            width='100%'
            variant='outline'
            color='white'
            background='#08101D'
            border='1px solid white'
            fontFamily='Metal'
            fontSize={['14px', '14px', '15px']}
            borderRadius='30px'
            whiteSpace='break-spaces'
            _hover={{
              bg: 'white',
              color: '#08101D',
              _disabled: {
                bg: '#08101D',
                color: 'white',
              },
            }}
            isDisabled={
              (planType === 'Paid' && current) ||
              (planType === 'Free' && current)
            }
            onClick={onClick}
          >
            {planType === 'Paid' && current
              ? 'Current Plan'
              : planType === 'Free' && current
              ? 'Current Plan'
              : planType === 'Free'
              ? 'Cancel Paid Plan'
              : 'Contact Sales'}
          </Button>
        )}
      </Box>

      {/* Free Plan Features */}

      {planType === 'Free' && (
        <Flex padding='30px' direction='column' gap={5}>
          <Box>
            <Heading fontWeight='600' fontSize='12px'>
              Storage & Bandwidth
            </Heading>
            <Flex direction='column' color='gray.500' mt={1} gap={1}>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Upload / storage{' '}
                <Box as='span' color='#D3BB8A'>
                  500 MB
                </Box>
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Bandwidth{' '}
                <Box as='span' color='#D3BB8A'>
                  5 GB
                </Box>
              </Flex>
            </Flex>
          </Box>

          <Box>
            <Heading fontWeight='600' fontSize='12px'>
              Virtual Experience Creation:
            </Heading>
            <Flex color='gray.500' direction='column' mt={1} gap={1}>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Single Sign On
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Pre-built
                interactions
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Template scenes
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Procedural
                Generation Tools
              </Flex>
            </Flex>
          </Box>
        </Flex>
      )}

      {/* Paid Plan Features */}
      {planType !== 'Free' && (
        <Flex padding='30px' justifyContent='space-between' gap={2}>
          <Flex direction='column' gap={5}>
            <Heading fontWeight='600' fontSize='12px'>
              All of Free +
            </Heading>
            <Flex direction='column' gap={1}>
              <Heading fontWeight='600' fontSize='12px'>
                Experience Creation:
              </Heading>
              <Flex color='gray.500' direction='column' gap={1}>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> Custom domains
                </Flex>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> Custom UI
                </Flex>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> White-label
                </Flex>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> 3D navigation
                  (coming soon)
                </Flex>
              </Flex>
            </Flex>
            <Flex direction='column' gap={1}>
              <Heading fontWeight='600' fontSize='12px'>
                UX & Interaction:
              </Heading>
              <Flex color='gray.500' direction='column' gap={1}>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> Custom logic &
                  interactions
                </Flex>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> API integrations
                </Flex>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> Token Gated
                  Rooms
                </Flex>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> Gamification
                  features
                </Flex>
                <Flex
                  gap={2}
                  alignItems='center'
                  fontSize='12px'
                  fontWeight='400'
                >
                  <CheckIcon fontSize='12px' color='#58677E' /> Connectivity
                  tools (coming soon)
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <Flex direction='column' gap={1}>
            <Heading fontWeight='600' fontSize='12px'>
              Analytics & Management:
            </Heading>
            <Flex color='gray.500' direction='column' gap={1}>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Analytics
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Commerce tools
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Data Export
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Markets
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Role Controls{' '}
                {`{RBAC}`}
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Security
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Dedicated Success
                Manager
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Self-Hosted
                Infrastructure
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Managed SaaS
              </Flex>
              <Flex
                gap={2}
                alignItems='center'
                fontSize='12px'
                fontWeight='400'
              >
                <CheckIcon fontSize='12px' color='#58677E' /> Services
                Availability
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      )}
    </Box>
  );
}
